


























































































import { RouterNames } from "@/router/routernames";
import { lecturas_codigo_barras } from "@/shared/dtos/lecturas_codigo_barras";
import lecturas_codigo_barrasModule from "@/store/modules/lecturas_codigo_barras-module";
import { UtilsString } from "@/utils/utils-string";
import { Component, Ref, Vue } from "vue-property-decorator";
import ProductoEscaneado from "./prodcuto-escaneado.vue";
@Component({
  components: { ProductoEscaneado },
})
export default class EscanearProdcutoFisico extends Vue {
  public decodeBarcode = "";
  public BarCode: string = "";
  public decodedText: string = "";
  public imagen = "USB.JPG";
  public show_imagen = false;

  onScan(decodedText: string, decodedResult: string) {
    // handle the message here :)
    if (UtilsString.IsNullOrWhiteSpace(decodedText)) {
      return;
    }
    if (this.decodeBarcode !== decodedText) {
      var codigo = new lecturas_codigo_barras();
      codigo.referencia = decodedText;
      codigo.dispositivo = "Lector Fisico";
      lecturas_codigo_barrasModule.guardarlecturas_codigo_barras(codigo);

      this.decodeBarcode = decodedText;
      this.BarCode = this.decodeBarcode;
    }
    this.decodedText = "";
  }

  get UtilsString() {
    return UtilsString;
  }
}
